import React, { useEffect, useState } from "react";
import MonthNavigator from "../Balanceview/MonthNavigator";
import Order from "./Order";
import { useDispatch } from "react-redux";
import { shareOrderSheet } from "../../redux/thunks/customerRecordThunk";
import toast from "react-hot-toast";

const Ordersheet = (customerId) => {
  const dispatch = useDispatch();

  const getMonthRange = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);

    const end = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    const format = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate(),
      ).padStart(2, "0")}`;

    return {
      start_date: format(start),
      end_date: format(end), // 🔥 IMPORTANT
    };
  };

  const onShareOrder = () => {
    const { start_date, end_date } = getMonthRange(currentDate);

    dispatch(
      shareOrderSheet({
        service_provider_customer_id: customerId,
        start_date,
        end_date,
      }),
    )
      .unwrap()
      .then((res) => {
        const { file_url, file_name } = res.data;

        // 🔽 download trigger
        const link = document.createElement("a");
        link.href = file_url;
        link.download = file_name || "balance_sheet.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        if (res.success) {
          toast.success(res.message || "Order sheet exported successfully");
        }
      });
  };
  const [currentDate, setCurrentDate] = useState(new Date());
  return (
    <>
      <div className="max-w-full mx-auto bg-white rounded-xl shadow p-4 space-y-4">
        <MonthNavigator date={currentDate} onChange={setCurrentDate} />

        <div className="flex justify-between items-center">
          <h2 className="font-semibold text-sm">Tiffins Ordered</h2>
          <button
            className="border border-[#FF6943] text-[#FF6943] px-3 py-1 rounded-full text-xs"
            onClick={onShareOrder}
          >
            Share Order History
          </button>
        </div>

        <Order currentDate={currentDate} customerId={customerId} />
      </div>
    </>
  );
};

export default Ordersheet;
